// Rotate confirmation modal component

import React from 'react';
import { AlertTriangle } from 'lucide-react';

interface RotateModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

export function RotateModal({ isOpen, onConfirm, onCancel, isLoading }: RotateModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
      <div className="bg-card border border-border rounded-xl p-6 max-w-md w-full mx-4">
        <h2 className="text-xl font-semibold mb-4 text-foreground">Rotate License Key?</h2>

        <div className="mb-6">
          <p className="text-muted-foreground mb-3">
            This will generate a new license key and send it to your email.
          </p>
          <p className="text-muted-foreground mb-3">
            Your current key will continue to work for <strong className="text-foreground">24 hours</strong>, giving you time to update your installation.
          </p>
          <div className="bg-amber-500/10 border border-amber-500/30 rounded-lg p-3 mt-4 flex items-start gap-2">
            <AlertTriangle className="w-4 h-4 text-amber-400 mt-0.5 flex-shrink-0" />
            <p className="text-sm text-amber-300">
              <strong>Note:</strong> You can only rotate your key 3 times per day.
            </p>
          </div>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onCancel}
            disabled={isLoading}
            className="flex-1 border border-border text-foreground px-4 py-2.5 rounded-md hover:bg-secondary transition-colors disabled:opacity-50 bg-transparent text-sm font-medium"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className="flex-1 bg-destructive text-white font-medium px-4 py-2.5 rounded-md hover:bg-destructive/90 transition-all disabled:opacity-50 text-sm"
          >
            {isLoading ? 'Rotating...' : 'Rotate Key'}
          </button>
        </div>
      </div>
    </div>
  );
}
